import React from 'react';
import { GlobalStyle } from 'assets/styles/GlobalStyle';
import { ThemeProvider } from 'styled-components';
import { theme } from 'assets/styles/theme';
import Form from 'components/templates/Form';
import { HashRouter as Router, Switch, Route, Link } from 'react-router-dom';
// import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';

import CookieConsent from 'react-cookie-consent';
import { createBrowserHistory } from 'history';
import ScrollToTop from 'components/molecules/ScrollToTop';
import Offer from 'components/templates/Offer';
import StartPage from 'components/templates/StartPage';
import FirstPageRoutes from 'components/templates/FirstPageRoutes';
import SecondPageRoutes from 'components/templates/SecondPageRoutes';
import ThirdPageRoutes from 'components/templates/ThirdPageRoutes';
import AboutUs from 'components/templates/AboutUs';
import MainPage from 'components/templates/MainPage';
import OzeOffer from 'components/templates/OzeOffer';
import EleOffer from 'components/templates/EleOffer';
import Cookie from 'components/molecules/Cookie/Cookie';

const history = createBrowserHistory();

const Root = () => (
  <Router basename={process.env.PUBLIC_URL} history={history}>
    <ThemeProvider theme={theme}>
      <GlobalStyle />

      <CookieConsent
        location="bottom"
        cookieName="myAwesomeCookieName3"
        expires={999}
      >
        Nasza strona wykorzystuje pliki cookie służące do ulepszenia
        funkcjonalności oraz ułatwienia korzystania z serwisu. Witryna może
        również zawierać pliki cookie innych podmiotów. Korzystanie z niniejszej
        witryny internetowej jest równoznaczne ze zgodą użytkownika na
        stosowanie plików cookie.
        <Link to="/polityka">Wiecej</Link>
      </CookieConsent>
      <ScrollToTop />
      {/* <Header /> */}
      <Switch>
        <Route path="/" exact>
          <AboutUs />
        </Route>
        <Route path="/kontakt">
          <Form />
        </Route>
        <Route path="/elgreen-projekt">
          <Offer />
        </Route>
        <Route path="/elgreen-electromobility">
          <EleOffer />
        </Route>
        <Route path="/elgreen-oze">
          <OzeOffer />
        </Route>
        <Route path="/polityka">
          <Cookie />
        </Route>
      </Switch>
    </ThemeProvider>
  </Router>
);

export default Root;
